import BaseButton from "Engine/base/ui/BaseButton";
import {TweenMax, Expo, Linear} from "gsap";
import Utils from "Engine/Utils";
import StatesManager from "Engine/base/states/StatesManager";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import AutoPlaySettings from "Base/settings/AutoPlaySettings";
import EntryPoint from "Engine/EntryPoint";

export default class BaseMobileSpinButton extends BaseButton {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.contentState = 1;
        this.incativeTintColor = 0xCCCCCC;

        this.init();
        this.createTweens();
    }

    init() {
        super.init();
        this.backgroundImage = this.getChildAt(0);
        this.content = this.getChildByName('content');
        /*this.image = this.getChildAt(1);
        this.image.pivot.set(this.image.width / 2, this.image.height / 2);
        this.image.x += this.image.width / 4;
        this.image.y += this.image.height / 4;*/

        if (AutoPlaySettings.active) {
            this.onAutoPlayCountChanged({params:AutoPlaySettings.count});
        }
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('autoPlaySettings:activeChanged', this.onAutoPlayActiveChanged, this);
        GlobalDispatcher.add('autoPlaySettings:countChanged', this.onAutoPlayCountChanged, this);
        GlobalDispatcher.add('autoPlaySettings:selectedCountChanged', this.onAutoPlaySelectedCountChanged, this);
        GlobalDispatcher.add('ui:openAutoPlayPopup', this.onOpenAutoPlayPopup, this);
    }

    createTweens() {
        this.tween1 = TweenMax.to(this.content, 1, {
            rotation: '+=' + Utils.degToRad(360),
            ease: Expo.easeOut,
            paused: true
        });
        this.tween2 = TweenMax.to(this.content.scale, 0.15, {
            x: '-=' + 0.15,
            y: '-=' + 0.15,
            repeat: 1,
            yoyo: true,
            ease: Linear.easeNone,
            paused: true
        });
    }

    onClick() {
        super.onClick();
        if (this.contentState !== 1) {
            return;
        }
        switch (StatesManager.currentState.stateData.name) {
            case 'idleState':
                this.tween1.play(0);
                break;
            default:
                this.tween2.play(0);
                break;
        }
    }

    onAutoPlayActiveChanged(event) {
        if (EntryPoint.GameModel.isFreeSpins || EntryPoint.GameModel.freeBets) {
            return;
        }
        if (!event.params) {
            this.contentState = 1;
            this.content.goToFrame(this.contentState);
            this.enabled = this._enabled;
        }
    }

    onAutoPlayCountChanged(event) {
        if (EntryPoint.GameModel.isFreeSpins || EntryPoint.GameModel.freeBets) {
            return;
        }
        this.contentState = 3;
        this.content.goToFrame(this.contentState);
        this.content.getChildByName('valueText').text = event.params.toString();
    }

    onAutoPlaySelectedCountChanged(event) {
        if (EntryPoint.GameModel.isFreeSpins || EntryPoint.GameModel.freeBets) {
            return;
        }
        this.contentState = 2;
        this.content.goToFrame(this.contentState);
        this.content.getChildByName('valueText').text = event.params.toString();
    }

    onOpenAutoPlayPopup(event) {
        if (!event.params) {
            this.contentState = 1;
            this.content.goToFrame(this.contentState);
        }
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        if (this.contentState !== 1) {
            return;
        }

        if (value) {
            this.goToFrame(this.state === 'over' ? 2 : 1);
            this.interactive = true;
            this.buttonMode = true;
        } else {
            this.goToFrame(4);
            this.interactive = false;
            this.buttonMode = false;
        }
        this.children.forEach((child) => {
            child.tint = this._enabled ? 16777215 : this.incativeTintColor;
        });
    }

    destroy(options) {
        GlobalDispatcher.remove('autoPlaySettings:activeChanged', this.onAutoPlayActiveChanged, this);
        GlobalDispatcher.remove('autoPlaySettings:countChanged', this.onAutoPlayCountChanged, this);
        GlobalDispatcher.remove('autoPlaySettings:selectedCountChanged', this.onAutoPlaySelectedCountChanged, this);
        GlobalDispatcher.remove('ui:openAutoPlayPopup', this.onOpenAutoPlayPopup, this);
        super.destroy(options);
    }
}